import { CoreTypography } from '@youscience/core';
import { useLocation } from 'react-router-dom';

import { BREADCRUMBS_NAVIGATION_DATA, BREADCRUMBS_PAGE_TEXT } from '@constants/breadcrumbs';
import { EDC_HASH } from '@constants';

import { Breadcrumbs } from '@components/Breadcrumbs';

import useCommonAppStore from '@store/CommonAppStore';

import { useAnyCommonAppEnabled } from '@hooks/useAnyCommonAppEnabled';

import AccountConnection from '../../components/CommonApp/AccountConnection';

import AddCounselor from '../CommonApp/AddCounselor';

import {
  sxStyles,
  StyledHero,
  StyledHeroMargin,
  StyledHeroTopContent,
  StyledHeroContentColumns,
  StyledHeroLeftContent,
  StyledHeroRightContent,
  StyledHeroLeftContentHeadline,
  StyledHeroBottomContent,
  StyledHeroContent,
} from './EducationPlannerHero.styles';

export const EducationPlannerHero = () => {
  const location = useLocation();

  const { anyTenantHasCommonApp } = useAnyCommonAppEnabled();

  const { commonAppConnected, isLoading } = useCommonAppStore((state) => state);

  return (
    <StyledHero>
      <StyledHeroMargin>
        <StyledHeroContent>
          <StyledHeroTopContent>
            <Breadcrumbs
              links={BREADCRUMBS_NAVIGATION_DATA[location.hash] || BREADCRUMBS_NAVIGATION_DATA[EDC_HASH]}
              currentPage={BREADCRUMBS_PAGE_TEXT.EDUCATION_PLANNER_SCHOOLS}
            />
          </StyledHeroTopContent>
          <StyledHeroContentColumns>
            <StyledHeroLeftContent>
              <StyledHeroLeftContentHeadline>
                <CoreTypography data-testid="heroTitle" sx={sxStyles.headTitle} variant="h4" component="h3">
                  College application progress tracker
                </CoreTypography>
                {anyTenantHasCommonApp && !commonAppConnected && !isLoading ? (
                  <CoreTypography>
                    Use Common App to simplify the college application process. Follow these three easy steps:
                  </CoreTypography>
                ) : null}
              </StyledHeroLeftContentHeadline>
            </StyledHeroLeftContent>
            {anyTenantHasCommonApp && commonAppConnected ? (
              <StyledHeroRightContent>
                <AddCounselor />
              </StyledHeroRightContent>
            ) : null}
          </StyledHeroContentColumns>
          <StyledHeroBottomContent>
            <AccountConnection />
          </StyledHeroBottomContent>
        </StyledHeroContent>
      </StyledHeroMargin>
    </StyledHero>
  );
};
